import { createSelector } from 'reselect'

const getClonePotentialLeaguesDataList = state => state.misc.potentialCloneCandidate

const getPotentialCloneCandidateData = createSelector(
  [ getClonePotentialLeaguesDataList ],
  (potentialCloneCandidate) => potentialCloneCandidate,
)

export default getPotentialCloneCandidateData
